import PageNotFound from "../views/PageNotFound";

const PageNotFoundRoute = {
  path: "*",
  element: <PageNotFound />,
};

export default PageNotFoundRoute;
